import styled from 'styled-components';
import Colors from 'constants/Colors';

export const TooltipWrap = styled.div`
  position: relative;
`;

export const Container = styled.div`
  margin-left: 15px;
  overflow: hidden;;

  span{
    width: 25vw;
    z-index: 5;
    background: #FFF;
    padding: 15px;
    border-radius:4px;
    font-size: clamp(0.3em, 0.5em + 1vw, 1em);
    font-weight:500;
    
    box-shadow: 0px 15px 15px rgba(0, 0, 0, 0.1);
    opacity: 0;
    transition: opacity 0.4s;
    visibility: hidden; // Ocultar o elemento da DOM
    position: absolute;
    bottom: calc(100% + 12px); // Calculando com css

    // Hack para deixar elemento centralizado
    left: 50%;
    transform: translateX(-50%);
    color: #312e38;

    // hack para adicionar uma flecha para baixo
    &::before {
      content: '';
      border-style: solid;
      border-color: #FFF transparent;
      border-width: 6px 6px 0px 6px;
      top:100%;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  &:hover span{
    opacity:1;
    visibility: visible; // hack para exibir o elemento da DOM
  }
`;

export const TooltipCircle = styled.div`
height: 20px;
width: 20px;
border-radius: 50%;
display: flex;
flex-direction: row;
justify-content:center;
align-items: center;
background-color: ${({ color }) => color ? color : Colors.PRIMARY} ;
margin-bottom: 5px;
cursor: pointer;
`